
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getToolName } from '../utils/toolUtils';

interface EmptyStateProps {
  activeTab: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ activeTab }) => {
  const navigate = useNavigate();
  
  return (
    <div className="text-center py-12 bg-gray-50 rounded-lg border border-dashed border-gray-300">
      <FileText className="h-12 w-12 text-gray-400 mx-auto mb-4" />
      <h3 className="text-lg font-medium text-gray-700">No saved items found</h3>
      <p className="text-gray-500 mt-2 mb-6">
        {activeTab === 'all' 
          ? "You haven't saved any content yet." 
          : `You haven't saved any ${getToolName(activeTab).toLowerCase()} content yet.`}
      </p>
      <Button 
        onClick={() => navigate('/bible-tools')}
        variant="outline"
      >
        Explore Bible Tools
      </Button>
    </div>
  );
};
